<template>
  <div>
    <div
      :class="'fab-input-order ' + (showOrderType ? 'open-fab' : '')"
      @click="openOrderTypes"
    >
      +
    </div>
    <div
      :class="'fab-shade ' + (showOrderType ? 'show-fab-container' : '')"
      @click="openOrderTypes"
    />
    <div
      :class="'fab-container ' + (showOrderType ? 'show-fab-container' : '')"
    >
      <p class="please-choose-meeage">Please Choose Order Type</p>
      <div v-if="outletData.only_dine_in" class="fab-content">
        <div :class="'order-type-item'" @click="goToOrder('dine-in')">
          <img class="shop-img" :src="require('@/assets/shop.svg')" alt />
          <p>Dine In Order</p>
        </div>
      </div>
      <template v-else>
        <div v-if="!isRamdanOutlet" class="fab-content">
          <div
            v-if="
              outletData.order_types &&
                outletData.order_types.includes(constants.PPDI)
            "
            :class="'order-type-item'"
            @click="goToOrder('dine-in')"
          >
            <img class="shop-img" :src="require('@/assets/shop.svg')" alt />
            <p>Dine In Order</p>
          </div>
          <div
            v-if="
              outletData.order_types &&
                outletData.order_types.includes(constants.TOP)
            "
            :class="'order-type-item'"
            @click="goToOrder('table-order')"
          >
            <img class="shop-img" :src="require('@/assets/shop.svg')" alt />
            <p>Table Order</p>
          </div>
          <div
            v-if="
              outletData.order_types &&
                outletData.order_types.includes(constants.PPTA)
            "
            class="order-type-item"
            @click="goToOrder('take-away')"
          >
            <img :src="require('@/assets/take-away.svg')" alt />
            <p>Takeaway Order</p>
          </div>
          <div
            v-if="
              outletData.order_types &&
                outletData.order_types.includes(constants.HMD)
            "
            :class="'order-type-item'"
            @click="goToOrder('delivery')"
          >
            <img class="shop-img" :src="require('@/assets/moto.svg')" alt />
            <p>Delivery Order</p>
          </div>
          <div class="order-type-item" @click="goToOrder('others')">
            <img :src="require('@/assets/other-order.svg')" alt />
            <p>Others</p>
          </div>
          <div class="order-type-item" @click="goToOrder('pos')">
            <img :src="require('@/assets/pos-order.svg')" alt>
            <p>EDC Payment</p>
          </div>
          <div class="order-type-item" @click="goToOrder('room')">
            <img :src="require('@/assets/room.png')" alt />
            <p>Room</p>
          </div>
        </div>
        <div v-if="isRamdanOutlet" class="fab-content">
          <div class="order-type-item" @click="goToOrder('take-away')">
            <img :src="require('@/assets/take-away.svg')" alt />
            <p>Takeaway Order</p>
          </div>
        </div>
      </template>
    </div>
    <div v-if="isEDC">
      <PosOrderTypeWithEDCStep
        v-if="togglePosOrder"
        :reload="reload"
        :handle-click-order-status="handleClickOrderStatus"
        :switch-order-type="switchOrderType"
        :hide-pos-order="hidePosOrder"
      />
    </div>
    <div v-else-if="newFlow">
      <PosOrderTypeWithStep
        v-if="togglePosOrder"
        :reload="reload"
        :handle-click-order-status="handleClickOrderStatus"
        :switch-order-type="switchOrderType"
        :hide-pos-order="hidePosOrder"
      />
    </div>
    <div v-else>
      <PosOrderType
        v-if="togglePosOrder"
        :reload="reload"
        :handle-click-order-status="handleClickOrderStatus"
        :switch-order-type="switchOrderType"
        :hide-pos-order="hidePosOrder"
      />
    </div>
  </div>
</template>
<script>
import constants from '@/utils/constants';
import PosOrderType from './PosOrderType.vue';
import PosOrderTypeWithStep from './PosOrderTypeWithStep.vue';
import PosOrderTypeWithEDCStep from './PosOrderTypeWithEDCStep.vue';

export default {
  components: {
    PosOrderType,
    PosOrderTypeWithStep,
    PosOrderTypeWithEDCStep,
  },
  props: {
    reload: { default: () => {}, type: Function },
    handleClickOrderStatus: { default: () => {}, type: Function },
    switchOrderType: { default: () => {}, type: Function },
  },
  data() {
    return {
      showOrderType: false,
      parseOutLet: {},
      link: '',
      outletData: {},
      isRamdanOutlet: false,
      constants,
      togglePosOrder: false,
      newFlow: false,
    };
  },
  computed: {
    isEDC() {
      return this.$store.state.isEDC;
    }
  },
  mounted() {
    let link = '';
    const host = window.location.host;
    if (host.includes('-staging')) {
      link = 'https://staging.qraved.com/web-delivery/restaurant/';
    } else if (host.includes('-id')) {
      link = 'https://www.qraved.com/web-delivery/restaurant/';
    } else {
      link = 'https://dev.qraved.com/web-delivery/restaurant/';
    }
    this.link = link;
  },
  methods: {
    openOrderTypes() {
      if (this.showOrderType) {
        return (this.showOrderType = false);
      }
      sessionStorage.removeItem('is-test-mode');
      const posOrderOutlet = localStorage.getItem('pos-order-outlet');
      if (posOrderOutlet && posOrderOutlet !== 'undefined') {
        const parseOutLet = JSON.parse(posOrderOutlet);
        if (!parseOutLet.id) {
          return this.$swal(
            constants.SOMETHING_WROING,
            'Select an outlet to continue',
            constants.STATUS_ERROR
          );
        }
        const VUE_APP_RAMADAN_OUTLETS = JSON.parse(
          process.env.VUE_APP_RAMADAN_OUTLETS || '[]'
        );
        this.$store
          .dispatch('GetOneStoreForNewPort', parseOutLet.id)
          .then((res) => {
            const order_types = res.data.result.order_types.filter(
              (item) => item !== constants.OTHERS
            );
            res.data.result.order_types = order_types;
            if (!res.data.result.order_types.length) {
              return this.$swal(
                constants.SOMETHING_WROING,
                'This outlet is not allowed to create order',
                constants.STATUS_ERROR
              );
            }
            this.isRamdanOutlet = VUE_APP_RAMADAN_OUTLETS.includes(
              String(res.data.result.outlet_code)
            );
            this.outletData = res.data.result;
            this.parseOutLet = parseOutLet;
            this.showOrderType = !this.showOrderType;
            this.newFlow = res.data.result.edc_payment_new_flow;
            sessionStorage.setItem(
              'outletData',
              JSON.stringify(res.data.result)
            );
          });
      }
    },
    async goToOrder(type) {
      sessionStorage.removeItem('pin_code');
      let outletCodes = localStorage.getItem('pos-order-outlet');
      if (!outletCodes) {
        return this.$swal(
          constants.SOMETHING_WROING,
          'You are not allowed to create order',
          constants.STATUS_ERROR
        );
      }
      outletCodes = JSON.parse(outletCodes);
      sessionStorage.setItem('order_type', type);
      const bo_user_id = localStorage.getItem('UID');
      if (type === 'pos') {
        this.openOrderTypes();
        this.togglePosOrder = true;
        return;
      }
      if (type === 'others') {
        return this.$router.push('/pos-order?type=others');
      }
      if (type === 'table-order') {
        return this.$router.push(
          `/select-table?type=${this.outletData.payment_order}`
        );
      }
      if (type === 'room') {
        return this.$router.push(
          `/select-building?type=${this.outletData.payment_order}`
        );
      }
      if (type === 'delivery') {
        return (location.href =
          this.link +
          outletCodes.seo_keyword +
          `?source=QBIZ&type=${type}&bo_user_id=${bo_user_id}`);
      }
      if (this.outletData.is_pos_input) {
        this.$router.push('/pos-order?type=' + type);
      } else {
        location.href =
          this.link +
          outletCodes.seo_keyword +
          `?source=QBIZ&type=${type}&bo_user_id=${bo_user_id}`;
      }
    },
    hidePosOrder() {
      this.togglePosOrder = false;
    },
  },
};
</script>
